import React from "react";

type AvailableInputTypes =
  | "date"
  | "datetime-local"
  | "email"
  | "number"
  | "password"
  | "search"
  | "tel"
  | "text"
  | "time"
  | "url";
interface BaseInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Name is used in the input elements id and labels elements for values to create a unique
   * label + input pair. If the name is not unique it will cause accessibility issues.
   * Usually you want to name the input after the data it will contain e.g mobile-number,
   * first-name, preferred-name etc. */
  name: string;
  /** Accepts most valid html input types */
  type: AvailableInputTypes;
  /** Optional placeholder text for an input */
  placeholderText?: string;
}

export const BaseInput: React.FC<BaseInputProps> = ({
  name,
  placeholderText,
  type,
  required,
  disabled,
  ...props
}) => {
  return (
    <input
      id={name}
      name={name}
      placeholder={placeholderText}
      className="input__field"
      disabled={disabled}
      aria-disabled={disabled}
      required={required}
      type={type}
      {...props}
    />
  );
};
